import { useQueryClient } from '@tanstack/react-query';
import { Graphback } from '../../graphql';
import { useStorageKeys } from '../../storage';
import { useSetCurrentWorkspace } from './useSetCurrentWorkspace';
import { useGrippContext } from '../../grippContext';

export const useLogout = () => {
  const { secureStorageHandler, storageHandler } = useGrippContext();
  const storageKeys = useStorageKeys();
  const queryClient = useQueryClient();
  const { mutateAsync: setCurrentWorkspace } = useSetCurrentWorkspace();

  return async () => {
    await secureStorageHandler.deleteItem(storageKeys.accessToken);
    // Signing out while impersonating a user must also drop the saved
    // original token — useIsInImpersonateUser treats its presence as "still
    // impersonating", so the next signed-in account would wrongly show an
    // active impersonation until a fresh code-login clears it.
    await secureStorageHandler.deleteItem(storageKeys.oldAccessToken);
    await storageHandler.clear();
    await queryClient.resetQueries();
    await queryClient.invalidateQueries();
    await setCurrentWorkspace(undefined);
    Graphback.dispose();
  };
};
